import { collections } from '@/mocks/home';

const toneBubble: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function CollectionsSection() {
  return (
    <section id="collections" className="bg-background-50 border-b border-background-200">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8 py-8 md:py-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-5 md:mb-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-900 bg-accent-100 px-3 py-1 rounded-full">
              <i className="ri-folders-line" />
              合集专题
            </span>
            <h2 className="mt-3 font-heading text-xl md:text-2xl font-black text-foreground-950">
              按专题一口气看完
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              同类事件归进同一个合集，不用在不同的时间线里来回跳。
            </p>
          </div>
          <a
            href="#archive"
            className="self-start md:self-auto inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap"
          >
            全部合集
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {collections.map((item) => (
            <article
              key={item.id}
              className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-foreground-400 transition-colors cursor-pointer"
            >
              <div className="flex items-start justify-between gap-3">
                <span className={`w-10 h-10 rounded-md flex items-center justify-center ${toneBubble[item.tone] ?? toneBubble.primary}`}>
                  <i className={`${item.icon} text-lg`} />
                </span>
                <span className="font-heading text-xs font-bold text-foreground-500">
                  {item.count} 条
                </span>
              </div>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs text-primary-700">
                进入合集
                <i className="ri-arrow-right-line" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}